import { call, put, takeLatest, delay } from "redux-saga/effects";

import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function* deleteEvidenceSaga({ payload }) {
    try {
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.DELETE_EVIDENCE,
            data: payload
        });

        if (apiResponse) {
            yield put({ type: ActionTypeConstants.DELETE_EVIDENCE_SUCCESS });
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: `Evidence deleted!`,
                    color: "success"
                }
            });
            yield put({ type: ActionTypeConstants.LOAD_EVIDENCE_BY_INCIDENT, payload: { id: payload.entity_id } });
            yield put({ type: ActionTypeConstants.LOAD_ONE_TASK, payload: { id: payload.entity_id } });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: `Error - Evidence not deleted!`,
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: `Error - Evidence not deleted!`,
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.DELETE_EVIDENCE, deleteEvidenceSaga);
}
